import { ValidateJSModel } from 'forms/shared/types';
import { hasYesOrNo } from 'models/validate';
import { ForeignActivitiesRealEstateModel } from './types';
import { foreignActivitiesRealEstateItemValidator } from './validators/item';

const foreignActivitiesRealEstateValidator: ValidateJSModel<ForeignActivitiesRealEstateModel> = {
  HasInterests: { hasValue: { validator: hasYesOrNo } },
  List: (value, attributes) => {
    if (attributes?.HasInterests?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: foreignActivitiesRealEstateItemValidator },
      };
    }

    return {};
  },
};
export default foreignActivitiesRealEstateValidator;
